import { jsx, jsxs } from "react/jsx-runtime";
import { Spinner, YStack } from "tamagui";
function SpinnerDemo() {
  return /* @__PURE__ */ jsxs(YStack, { padding: "$3", space: "$4", alignItems: "center", children: [
    /* @__PURE__ */ jsx(Spinner, { size: "small", color: "$green10" }),
    /* @__PURE__ */ jsx(Spinner, { size: "large", color: "$orange10" })
  ] });
}
export {
  SpinnerDemo
};
//# sourceMappingURL=SpinnerDemo.js.map
